import { Entity, formatTicker } from '@api';
import { AssetLogoContainer } from '@terminal/components/asset-logo-container/AssetLogoContainer';
import type { TerminalChartEntity } from '@terminal/views/turbo-chart/utils/chart-utils/types';

import styles from './AssetTickerLabel.module.scss';

const LOGO_SIZE = 20;

export interface AssetTickerLabelProps {
  entity: TerminalChartEntity;
}

export const AssetTickerLabel = ({ entity }: AssetTickerLabelProps) => {
  const ticker = (
    entity.formattedTicker ||
    formatTicker(entity) ||
    entity.name
  ).toUpperCase();

  return (
    <span className={styles.root}>
      <span className={styles.logoSlot} aria-hidden>
        <AssetLogoContainer entity={entity as Entity} size={LOGO_SIZE} />
      </span>
      <span className={styles.ticker}>{ticker}</span>
    </span>
  );
};
